import React from "react";
import {
    Card,
    CardBody,
    Progress
} from "shards-react";

class CardStat extends React.Component {
    render () {
        return (
            <Card className="cardStat">
                <CardBody>
                    <span className="cardStat__label">
                        {this.props.label}
                    </span>
                    <Progress className="progress-sm" value={this.props.value} style={{width:"100%",display:"block",height:"5px"}} striped></Progress>
                </CardBody>
            </Card>
        );
    }
}

export default CardStat;


// WEBPACK FOOTER //
// ./src/components/stats/CardProgress.js